export const header = [
  'City',
  'Week',
  'Date',
  'Time',
  'Time of day',
  'Day of week',
  'Spy',
  'Location',
  'BA',
  'Code',
  'Tag',
  'Flyers distributed',
  'Status',
  'Scans',
]
// The headers for the csv export file
export const exportHeaders = [
  'City',
  'Week',
  'Date',
  'Day of week',
  'Time',
  'Time of day',
  'Location',
  'Location Type',
  'BA',
  'Spy',
  'Code',
  'Tag',
  'Pack Size',
  'Flyers distributed',
  'Distribution Cost',
  'Printing Cost',
  'Permit Cost',
  'Cash Bonus',
  'Hard Cost',
  'Scans',
]
export const sortOn = [
  'City',
  'Date',
  'Time',
  'Time of day',
  'Day of week',
  'Week',
  'Location',
  'BA',
  'Code',
  'Flyers distributed',
  'Status',
]

export const getDynamicHeaders = (
  headers,
  metrics,
  exportMode = false,
  scanDataEnabled = true,
) => {
  let headersClone = []
  if (scanDataEnabled) {
    headersClone = [...headers]
  } else {
    const filteredHeaders = headers.filter(header => header !== 'Scans')
    headersClone = [...filteredHeaders]
  }
  // Add the metrics to the header and make them sortable
  metrics.forEach(({ label, name }) => {
    if (headersClone.includes(label)) {
      headersClone.push(`${label} 2`)
      headersClone.push(`Cost per ${label} 2`)
      headersClone.push(`${label} 2 CVR`)
      return
    }
    if (label) {
      headersClone.push(label)
      headersClone.push(`Cost per ${label}`)
      headersClone.push(`${label} CVR`)
      return
    } else {
      headersClone.push(name)
      headersClone.push(`Cost per ${name}`)
      headersClone.push(`${name} CVR`)
    }
  })

  exportMode &&
    headersClone.splice(
      headersClone.length,
      0,
      'Status',
      'Link',
      'Check In Time',
      'Checkout Time',
      'BA Payout',
      'Cost Per Flyer',
      'Zip Code',
    )

  return headersClone
}
